import React, { useRef,useState } from "react";
import "./login.css";
import LoginSignupSide from "../utils/LoginSignupSide";
import Input from "../utils/Input";
import { Paper } from "@material-ui/core";
import { useAuth } from "../../context/AuthContext";
import { Alert } from "@material-ui/lab";
import { useData } from "../../context/DataContext";

const Login = () => {
  // Getting Login Function from Auth Context
  const { login } = useAuth();
  const { website_details } = useData();
  // Error Handling
  const reject = error=>setError(error);
  const [error,setError] = useState(null);
  // Material UI Classes
  // Document Reference
  const email = useRef();
  const password = useRef();
  // Login on If Email & Password are correct else Throw Error
  const onSubmit = (e)=>{
    e.preventDefault();
    login(email.current.value,password.current.value,()=>{},reject)
  }
  return (
    <div style={{minHeight: `100vh`}}>
      <div className="login_outer login">
      <div className="login_container">
        <div className="login_content py-5">
          <Paper className="login_inner">
            <h1 className="font-weight-bold mt-4">Login to Your Account</h1>
            <form onSubmit={onSubmit} className="login_form">
              <div className="w-100 mb-3 d-flex justify-content-center align-items-center">
                <div className="line"></div>
                <p className="mb-0 font-smaller px-3">OR</p>
                <div className="line"></div>
              </div>
              <div className="fields">
                <Input type="email" ref={email} placeholder="Email" />
                <Input password={true} ref={password} type="password" placeholder="Password" />
              </div>
              <button className="button_login">Login</button>
            </form>
            {
              error && <Alert severity="error">
                {error.message}
              </Alert>
            }
          </Paper>
        </div>
        <LoginSignupSide
          type="signup_page"
          heading={website_details.website_name}
          text="Welcome to Admin Panel"
          link="/signup"
          linkText="Sign Up"
        />
      </div>
    </div>
    </div>
  );
};

export default Login;
